import React from "react";
import PropTypes from "prop-types";
import FieldTime from "../general-components/date-time/field-time";
import { useSelector } from "react-redux";

const NameDateWrapper = () => {
  const mainSettings = useSelector((state) => state.appStore.mainSettings);

  return (
    <div className="name-date-wrapper">
      <div className="spin-wrapper">
        <div className="title-and-date">
          <div className="spin-wrapper-inside">
            <h1 className="main-title body-m">Reeperbahn Festival</h1>
            <div className="festival-date body-m">
              {mainSettings?.fieldFestivalTime && (
                <>
                  <FieldTime
                    date={mainSettings?.fieldFestivalTime.value}
                    timestamp={false}
                    format={"DD.-"}
                  />
                  <FieldTime
                    date={mainSettings?.fieldFestivalTime.endValue}
                    timestamp={false}
                    format={"DD.MM.YYYY"}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NameDateWrapper.propTypes = {
  mainSettings: PropTypes.object,
  location: PropTypes.object,
};

export default NameDateWrapper;
